import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-conformation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.css'],
    standalone: false
})
export class ConformationDialogComponent {
  @Input() title: string ='';
  @Input() message: string='';
  @Input() btnOkText: string='';
  @Input() btnCancelText: string='';

  constructor(private activeModal: NgbActiveModal) { }

  
  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }
}
